"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveSavedIDState = /** @class */ (function () {
    function RemoveSavedIDState() {
        this.showIdModal = true;
        this.showAreYouSureModal = false;
        this.savedIds = [];
        this.idsToDelete = [];
    }
    return RemoveSavedIDState;
}());
exports.default = RemoveSavedIDState;
//# sourceMappingURL=RemoveSavedIDState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/RemoveSavedIDState.js
// module id = 1505
// module chunks = 8